import "./WhatsAppOpenButton.css";

interface WhatsAppOpenButtonProps {
  url: string;
  label?: string;
}

const WhatsAppOpenButton = ({ url, label = "Open WhatsApp" }: WhatsAppOpenButtonProps) => (
  <a
    className="msg-wa-btn"
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    title="Opens WhatsApp with the message pre-filled"
  >
    {label}
  </a>
);

export default WhatsAppOpenButton;